<ll-titulo>{{ "puntaje_core.estadisticas_evaluacion_recomendada.titulo" | t: { id: evaluacionSugeridaId } }}</ll-titulo>

<estadisticas-evaluacion-recomendada
    [evaluacionSugeridaId]="evaluacionSugeridaId"
></estadisticas-evaluacion-recomendada>
